<ng-container *transloco="let t">
  <div class="layout-grid" [ngClass]="{ 'with-subsidiaries': hasSubsidiaries() }">
    <app-header
      [establishment]="establishment()"
      [hasCartItems]="hasCartItems()"
      [displayAdminButton]="displayAdminButton()"
      [selectedLanguage]="selectedLanguage()"
      [availableLanguages]="availableLanguages()"
      [subsidiarySelector]="subsidiarySelector()"
      [searchText]="searchText()"
      [isSubsidiaryLanding]="isSubsidiaryLanding()"
      (searchTextChange)="onProductSearch($event)"
      (clickLateralMenu)="onClickLateralMenu($event)"
      (languageSelected)="onLanguageSelected($event)"
    />
    <div>
      <pxw-drawer [(isOpen)]="sideMenuOpen">
        <ng-template #sideMenu>
          <aside aria-label="Menú secundario">
            <app-side-menu
              (navItemClick)="onNavItemClick()"
              [selectedSubsidiaryId]="selectedSubsidiaryId()"
              (subsidiarySelected)="onSwitchSubsidiary($event)"
            />
          </aside>
        </ng-template>
        <aside>
          @if (!isSubsidiaryLanding()) {
            @if (displayWorkingHoursMessage()) {
              <app-working-hours-message
                [isClosed]="openedStatus()?.isClosed"
                [isAboutToClose]="openedStatus()?.isAboutToClose"
                [isTemporaryClosed]="openedStatus()?.isTemporaryClosed"
                [isInventoryBlocked]="openedStatus()?.isInventoryBlocked"
                [workingDays]="establishment().workingDays"
                [temporaryClosure]="establishment().temporaryClosure"
              ></app-working-hours-message>
            } @else if (displayAnnouncements()) {
              <app-announcements-message
                [announcements]="establishment().announcements"
                (announcementsHidden)="announcementsHidden.set(true)"
              />
            }
          }
        </aside>
        <main class="layout-router-wrapper">
          <article>
            @if (catalogIsEnabled()) {
              <router-outlet class="layout-router-outlet"></router-outlet>
            } @else {
              <div class="catalog-disabled">
                <h6>{{ t('workingHours.weAreClosed') }}</h6>
                @if (establishment().temporaryClosure?.message) {
                  <p class="subtitle">
                    {{ establishment().temporaryClosure?.message }}
                  </p>
                }
              </div>
            }
          </article>
        </main>
        <footer>
          @if (hasLegalLinks()) {
            <div class="legal-links">
              @if (establishment().links?.returnPolicy) {
                <a
                  [href]="establishment().links.returnPolicy"
                  target="_blank"
                  rel="noopener noreferrer"
                  >{{ t('legalLinks.returnPolicy') }}</a
                >
              }
              @if (establishment().links?.privacyPolicy) {
                <a
                  [href]="establishment().links.privacyPolicy"
                  target="_blank"
                  rel="noopener noreferrer"
                  >{{ t('legalLinks.privacyPolicy') }}</a
                >
              }
              @if (establishment().links?.termsOfService) {
                <a
                  [href]="establishment().links.termsOfService"
                  target="_blank"
                  rel="noopener noreferrer"
                  >{{ t('legalLinks.termsOfService') }}</a
                >
              }
              @if (establishment().links?.withdrawalButton) {
                <a
                  [href]="establishment().links.withdrawalButton"
                  target="_blank"
                  rel="noopener noreferrer"
                  >{{ t('legalLinks.withdrawalButton') }}</a
                >
              }
            </div>
          }
        </footer>
      </pxw-drawer>
    </div>
  </div>

  @if (loading()) {
    <div class="ui-loader ui-loader--with-overlay">
      <pxw-icon icon="loading" [spin]="true"></pxw-icon>
    </div>
  }
</ng-container>
